/**
 * Test IDs for QA automation.
 */
export const testIds = {
  bestBuyModalApply: "best-buy-modal-apply",
} as const;
